import React, { useState, useEffect } from 'react';
import { CssBaseline } from '@material-ui/core';
import {
	BrowserRouter as Router,
	Switch,
	Route,
	useLocation,
	withRouter,
} from 'react-router-dom';

import {
	Navbar,
	Products,
	Cart,
	Checkout,
	Hero,
	Marquee,
	Footer,
	Sections,
	OurStory,
	ContactUs,
} from './components';
import { commerce } from './lib/commerce';

const App = () => {
	const [mobileOpen, setMobileOpen] = React.useState(false);
	const [products, setProducts] = useState([]);
	const [cart, setCart] = useState({});
	const [order, setOrder] = useState({});
	const [errorMessage, setErrorMessage] = useState('');

	const fetchProducts = async () => {
		const { data } = await commerce.products.list();

		setProducts(data);
	};

	const fetchCart = async () => {
		setCart(await commerce.cart.retrieve());
	};

	const handleAddToCart = async (productId, quantity) => {
		const item = await commerce.cart.add(productId, quantity);

		setCart(item.cart);
	};

	const handleUpdateCartQty = async (lineItemId, quantity) => {
		const response = await commerce.cart.update(lineItemId, { quantity });

		setCart(response.cart);
	};

	const handleRemoveFromCart = async (lineItemId) => {
		const response = await commerce.cart.remove(lineItemId);

		setCart(response.cart);
	};

	const handleEmptyCart = async () => {
		const response = await commerce.cart.empty();

		setCart(response.cart);
	};

	const refreshCart = async () => {
		const newCart = await commerce.cart.refresh();

		setCart(newCart);
	};

	const handleCaptureCheckout = async (checkoutTokenId, newOrder) => {
		try {
			const incomingOrder = await commerce.checkout.capture(
				checkoutTokenId,
				newOrder
			);

			setOrder(incomingOrder);

			refreshCart();
		} catch (error) {
			setErrorMessage(error.data.error.message);
		}
	};

	useEffect(() => {
		fetchProducts();
		fetchCart();
	}, []);

	const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

	function _ScrollToTop(props) {
		const { pathname } = useLocation();
		useEffect(() => {
			window.scrollTo(0, 0);
		}, [pathname]);
		return props.children;
	}

	const ScrollToTop = withRouter(_ScrollToTop);

	return (
		<Router>
			<ScrollToTop>
				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<CssBaseline />
					<Navbar
						totalItems={cart.total_items}
						handleDrawerToggle={handleDrawerToggle}
					/>
					<Marquee />
					<Switch>
						<Route exact path="/">
							<Hero />
							<Sections />
						</Route>
						<Route exact path="/products">
							<Products
								products={products}
								onAddToCart={handleAddToCart}
								handleUpdateCartQty
							/>
						</Route>
						<Route exact path="/cart">
							<Cart
								cart={cart}
								onUpdateCartQty={handleUpdateCartQty}
								onRemoveFromCart={handleRemoveFromCart}
								onEmptyCart={handleEmptyCart}
							/>
						</Route>
						<Route path="/checkout" exact>
							<Checkout
								cart={cart}
								order={order}
								onCaptureCheckout={handleCaptureCheckout}
								error={errorMessage}
							/>
						</Route>
						<Route path="/our-story" exact>
							<OurStory />
						</Route>
						<Route path="/contact-us" exact>
							<ContactUs />
						</Route>
					</Switch>
					<Footer />
				</div>
			</ScrollToTop>
		</Router>
	);
};

export default App;
